import { useState, useRef, useEffect } from 'react';

import normalizeType from './use-normalize-type';
import useLoadMore from './use-load-more';
import { formatTokenAmount } from 'utils/amounts';
import { typeOptions } from 'lib/constants';
import { useAppSelector } from 'redux/use-hooks';
import { selectAccountId } from 'redux/slices/account';
import { nanoSecondsToDate } from 'utils';
import { exportToCsv } from './utils';

import Loader from 'components/common/loader/loader';
import Dropdown from 'components/common/form/dropdown/dropdown';
import DatePicker, {
  initialRange
} from 'components/common/date-range-picker/date-range-picker';

import SmallGreenCoinIcon from 'components/icons/SmallGreenCoinIcon';
import SignIcon from 'components/icons/SignIcon';

import {
  StyledWrapper,
  StyledScroll,
  StyledContentWrapper,
  StyledContentWrap,
  StyledCoinWrapper,
  StyledCoinLabel,
  StyledLabelWrapper,
  StyledContentLabel,
  StyledContentText,
  StyledHeader,
  StyledHeaderLabel,
  StyledInner,
  StyledBtn
} from './activity-element.style';

const ActivityElement = () => {
  const accountId = useAppSelector(selectAccountId);
  const [type, setType] = useState('');
  const [page, setPage] = useState(1);
  const [date, setDate] = useState(initialRange);
  const containerRef = useRef(null);
  const { data, setData, loadMore, isLoading, hasNextPage } = useLoadMore();

  const handleScroll = async (event) => {
    const container = event.target;
    if (
      container.scrollHeight - container.scrollTop ===
      container.clientHeight
    ) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    (async function () {
      if (accountId) {
        await loadMore(accountId, page, type, date);
      }
    })();
  }, [accountId, page, type, date]);

  return (
    <StyledWrapper>
      <StyledHeader>
        <StyledInner>
          <StyledHeaderLabel>Type</StyledHeaderLabel>
          <Dropdown
            value={type}
            onChange={(e) => {
              setType(e.target.value);
              setPage(1);
              setData([]);
            }}
            options={typeOptions}
          />
        </StyledInner>
        <StyledInner>
          <StyledHeaderLabel>Date</StyledHeaderLabel>
          <DatePicker
            onChange={(d) => {
              setDate(d);
              setPage(1);
              setData([]);
            }}
          />
        </StyledInner>
        <StyledInner>
          <StyledHeaderLabel>&nbsp;</StyledHeaderLabel>
          <StyledBtn onClick={() => exportToCsv(accountId, type, date)}>
            <SignIcon color="#d5d9e7" />
            Download CSV
          </StyledBtn>
        </StyledInner>
      </StyledHeader>
      <StyledScroll
        ref={containerRef}
        onScroll={data.length > 0 ? handleScroll : undefined}
      >
        <>
          {data.length === 0
            ? 'No items'
            : data.map((item) => {
                const { receipt_id, date_added } = item;
                const { amount, label, title } = normalizeType(item);

                return (
                  <StyledContentWrapper key={`${receipt_id}-${date_added}`}>
                    <StyledContentWrap>
                      <StyledCoinWrapper>
                        <SmallGreenCoinIcon />
                        <StyledCoinLabel>{label}</StyledCoinLabel>
                      </StyledCoinWrapper>
                      <StyledLabelWrapper>
                        <StyledContentLabel>{title}</StyledContentLabel>
                      </StyledLabelWrapper>
                    </StyledContentWrap>
                    <StyledLabelWrapper>
                      <StyledContentLabel right>
                        {formatTokenAmount(amount, 24, 5)}
                      </StyledContentLabel>
                      <StyledContentText>
                        {nanoSecondsToDate(date_added, true)}
                      </StyledContentText>
                    </StyledLabelWrapper>
                  </StyledContentWrapper>
                );
              })}
          {isLoading && hasNextPage && <Loader />}
        </>
      </StyledScroll>
    </StyledWrapper>
  );
};

export default ActivityElement;
